<tt-page *ngIf="!!get">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="pickjobgrp_name" [(ttModel)]="get.pickjobgrp_name" [ttButtons]="pickJobGroupKeyno > '0' ? pickJobGroupNameButtons : []" [ttReadonly]="pickJobGroupKeyno > '0'"></tt-input>
        <tt-input ttLabel="stockplace_name" [(ttModel)]="get.stockplace_name" ttReadonly></tt-input>
        <tt-select
            ttLabel="std_stocklocation_keyno_unload"
            [(ttModel)]="get.std_stocklocation_keyno_unload"
            [ttData]="stockLocations"
            ttDataId="stocklocation_keyno"
            ttDataName="stocklocation_name"
        ></tt-select>
        <tt-select ttLabel="stocklocation_keyno_trolley" [(ttModel)]="get.stocklocation_keyno_trolley" [ttData]="trolleys" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-select ttLabel="businesssite" [(ttModel)]="get.businesssite_keyno" [ttData]="businessSites" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-checkbox ttLabel="is_active" [(ttModel)]="get.is_active"></tt-checkbox>
        <tt-button-save class="col-xs-12 col-md-4 sp-0 pull-right" ttText="pickjobgrp_save" (ttClick)="save()"></tt-button-save>
        <tt-button *ngIf="pickJobGroupKeyno > '0'" class="col-xs-12 col-md-4 sp-0" ttText="pickjobgrp_delete" (ttClick)="delete()" ttType="danger"></tt-button>
    </tt-card>
</tt-page>
